import React from "react";
import classNames from "classnames";
import useDarkMode from "../../../hooks/useDarkMode";
import Footer from "../../../layout/Footer/Footer";

const DefaultFooter = () => {
  const { darkModeStatus } = useDarkMode();
  const currentYear = new Date().getFullYear();

  return (
    <Footer>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <span className="fw-light">
              ePaymentAmerica © {currentYear} All Rights Reserved.
            </span>
          </div>
          <div className="col-auto">
            <a
              href="/"
              className={classNames("text-decoration-none", {
                "link-dark": !darkModeStatus,
                "link-light": darkModeStatus,
              })}
            >
              <div>
                <small className="fw-bold">Privacy policy</small>
                <span style={{ marginLeft: "10px" }}></span>
                <small className="fw-bold">Terms Of Use</small>
              </div>
            </a>
          </div>
        </div>
      </div>
    </Footer>
  );
};

export default DefaultFooter;
